import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { interval } from 'rxjs';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { DMarketRuleComponent } from 'src/app/@shared/components/market-rule/d-market-rule/d-market-rule.component';
import { MMarketRuleComponent } from 'src/app/@shared/components/market-rule/m-market-rule/m-market-rule.component';
import { MessageService } from 'src/app/@shared/message/message.service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';

@Component({
    selector: 'app-multi-market',
    template: `
  <app-m-multi-market *ngIf="env.isMobile"></app-m-multi-market>
  <app-d-multi-market *ngIf="!env.isMobile"></app-d-multi-market>
  `,
    styles: []
})
export class MultiMarketComponent extends BaseClass<any> implements OnInit {

    @ViewChild('betSlipModal', { static: false }) betSlipModal?: ModalDirective;
    
    public data: any;
    public marketsReq: any[] = [];
    public marketIds: any[] = [];
    public multiMarketIds: any[] = [];
    public token: any = '';
    public newOddsEnable: boolean = false;
    public marketData: any;
    public oddsLisDisNew: any = {};
    public oddsLisDis: any = {};
    public betSlipData: any = {};
    public oodsList: any[] = [];
    public exposLisDis: any = {};
    public nextExpoList: any = {};
    public betCount: any = 0;

    constructor(
        public service: WebserviceService, 
        public _common: CommonService,
        public router: Router,
        public _message: MessageService,
        protected modalService: BsModalService,
        ) {
        super(document);
    }

    constructorCallData() {
        //emit value in sequence every given second\
        const sub1 = interval(this.env.pollers.oddsData).subscribe(val => {
            if (this.webSocketUrl != '') {
                if (this.newOddsEnable == true) {
                    this.getOddsNew(this.marketsReq, this.marketData);
                } else {
                    this.getOdds(this.marketsReq);
                }
            }
        });
        this.subs.push(sub1);
    }

    ngOnInit(): void {
    }

    getServices(): IbaseService<any> {
        return this.service;
    }

    getData() {
        this.isLoad = true;
        this.getServices().Get(`${this.env.baseUrl + this.api.multiMarket}`).subscribe(
            (res) => {
                if (res.status == true) {
                    this.data = Object.entries(res.data.fav_markets).map(([key, value]) => (value));
                    this.marketsReq = this._common.createMarketIdList(this.data) as any;
                    this.marketIds = this._common.createMarketIds(this.data) as any;
                    this.token = res?.data?.token;
                    this.multiMarketIds = JSON.parse(res?.data?.active_markets);
                    
                    this.webSocketUrl = (res.data.connect_odds_hub == true) ? `https://${res.data.odds_hub}` : this.env.baseUrl;
                    this.setLocalItem('ws', this.webSocketUrl, false);

                    this.data.forEach((element: any, i: any) => {
                        let fancyItems: any[] = element.filter((item: any) => item.market_id[0] == '9');
                        let dt = element.filter((item: any) => item.market_id[0] != '9');
                        if (fancyItems.length > 0) {
                            let fis: any[] = [];
                            fancyItems.forEach(element => {
                                element.fancy['sort_priority'] = 0;
                                fis.push(element.fancy);
                            });
                            dt.push({ market_id: fancyItems[0]?.market_id, event_type_id: fancyItems[0]?.event_type_id, market_type_id: 'FANCY', event_id: fancyItems[0]?.event_id, allFancy: [0], name: fancyItems[0]?.event?.name, sort: 3, data: fis })
                        }

                        this.data[i] = dt
                    });



                    this.data.forEach((element: any) => {
                        let mdt = element.filter((item: any) => item.market_id[0] == '1')
                        mdt.forEach((mEle: any) => {
                            mEle['sort'] = mEle?.market_type_id == 'MATCH_ODDS' ? 1 : 4
                        });
                        let bdt = element.filter((item: any) => item.market_id[0] == '8')
                        bdt.forEach((bEle: any) => {
                            bEle['sort'] = 2
                        });


                    });



                    this.data.forEach((element: any) => {
                        element.sort((a: any, b: any) => (a.sort > b.sort) ? 1 : -1);
                    });

                    // this.data.sort((a:any, b:any) => (a.sort > b.sort) ? 1 : -1);
                    if (res?.data?.bm_new_enable == true && res?.data?.fancy_new_enable == true && res?.data?.odds_new_enable == true) {
                        this.newOddsEnable = true;
                        this.marketData = res?.data;
                        this.getOddsNew(this.marketsReq, res.data);
                    } else {
                        this.newOddsEnable = false;
                        this.getOdds(this.marketsReq);
                    }
                    this.getExposure(this.marketsReq, this.data);
                    //console.log(this.data);
                }
            },
            (err) => {
                console.log(err);
            });
    }

    getOddsNew(req: any, resData: any) {
        this.getServices().Post(`${this.webSocketUrl + this.api.oddsNew}`, req).subscribe(
            (res) => {
                res = this.pipe_string_to_JSON(res);
                let resOdds: any = this._common.arrangeGetMarketNewData(res, resData);

                if (this.oddsLisDisNew.length == 0) {
                    this.oddsLisDisNew = resOdds;
                } else {
                    let newOddsLD = resOdds;
                    Object.keys(newOddsLD).forEach(key => {
                        if (Object.keys(this.oddsLisDisNew).includes(key)) {
                            delete this.oddsLisDisNew[key];
                        }
                    });
                    this.oddsLisDisNew = { ...this.oddsLisDisNew, ...newOddsLD }
                }
                this.setOdds(this.oddsLisDisNew);
                this.isLoad = false;
            },
            (err) => {
                console.log(err);
            });
    }

    setOdds(item: any) {

        Object.keys(item).forEach((key: any) => {
            if (item[key].runners) {
                let temp = Object.assign({}, ...item[key].runners.map((elt: any) => ({ [elt.selectionId]: elt })));
                item[key]['cRunners'] = temp;
            }
            if (item[key].book_maker_odds) {
                let temp = Object.assign({}, ...item[key].book_maker_odds.map((elt: any) => ({ [elt.selection_id]: elt })));
                item[key]['cRunners'] = temp;
            }
        });

        this.oddsLisDis = item;
        this.betSlipData['oddsLisDis'] = item;
    }

    getOdds(req: any) {
        this.getServices().Post(`${this.webSocketUrl + this.api.odds}`, req).subscribe(
            (res) => {
                res = this.string_to_JSON(res);
                this.oodsList = this._common.compareData(res, this.oodsList);
                let oods = Object.assign({}, ...this.oodsList.map((elt: any) => ({ [elt.marketId ? elt.marketId : elt.market_id]: elt })));
                this.setOdds(oods);
                this.isLoad = false;
            },
            (err) => {
                console.log(err);
            });
    }

    getExposure(req: any, items: any) {
        this.getServices().Post(`${this.env.baseUrl + this.api.exposure}`, req).subscribe(
            (res) => {
                if (res.status == true) {
                    res = res.data.exposes;
                    res = this.string_to_JSON(res);
                    items = this.setExposeData(items, res);
                    this.data = items;
                    this.isLoad = false;
                }
            },
            (err) => {
                console.log(err);
            });
    }

    tempExpo: any[] = [];
    setExposeData(items: any, res: any) {
        if (items && res) {
            // average expose
            res.forEach((element: any) => {
                element.forEach((expo: any, i: any) => {
                    this.tempExpo.forEach((tEle: any) => {
                        if (tEle && tEle?.market_id == expo?.market_id && tEle[`${expo?.selection_id}`]?.expose) {
                            if (tEle?.market_id[0] == '9') {
                                expo.expose = Number(tEle[`${expo?.selection_id}`]?.expose);
                            } else {
                                expo.expose += Number(tEle[`${expo?.selection_id}`]?.expose);
                            }
                        }
                    });
                });
            });
            res.forEach((element: any) => {
                element.forEach((expo: any, i: any) => {
                    if (element.length == 2) {
                        if (i == 0) {
                            let avg_value: any;
                            avg_value = Math.abs((parseFloat(element[0].expose) / parseFloat(element[1].expose))).toFixed(2);
                            if (!isFinite(avg_value)) {
                                element[i]["average"] = '';
                            } else {
                                element[i]["average"] = ' (' + avg_value + ')';
                            }
                        } else {
                            let avg_value: any;
                            avg_value = Math.abs((parseFloat(element[1].expose) / parseFloat(element[0].expose))).toFixed(2);
                            if (!isFinite(avg_value)) {
                                element[i]["average"] = '';
                            } else {
                                element[i]["average"] = ' (' + avg_value + ')';
                            }
                        }
                    }
                });
            });
            res.forEach((element: any) => {
                let temp = Object.assign({}, ...element.map((elt: any) => ({ [elt.selection_id]: elt })));
                this.exposLisDis[element[0]?.marketId ? element[0]?.marketId : element[0]?.market_id] = temp;
            });
        }
        return items;
    }

    openBetPlace(e: any) {
        let data = this.betSlipData = this._common.getBetSlipData(e?.item, e?.oddsItem, e?.i, e?.bet, e?.oi, e?.bkOrLy, e?.key, this.token, `${e?.stake ? e?.stake : 0}`);
        this.betSlipData['oddsLisDis'] = this.oddsLisDis;
        this.nextExpoList = {};
    
        if (data && data?.price && Number(data?.price) != 0) {
          data['event_name'] = this.data?.event?.event?.name;
          // this.betSlipModal?.show();
        } else {
          this.betSlipData = {}
        }
    }

    closeBet(e: any) {
        this.betSlipModal?.hide();
        this.nextExpoList = {};
        this.betSlipData = {}
    }

    updateData(e: any) {
        this.token = e;
        this.betSlipData = {};
    }

    changeExpo(data: any) {
        data?.runners.forEach((element: any) => {
            if (element?.selectionId)
                this.nextExpoList[`${data?.market_id}-${element?.selectionId}`] = element.pnlNext;
            if (element?.selection_id)
                this.nextExpoList[`${data?.market_id}-${element?.selection_id}`] = element.pnlNext;
        });
    }

    multiMarketUpdate(item: any, key: any) {
        // console.log(item);
        let url = (key == 'save') ? `${this.api.saveMultiMarket}/${item?.market_id}/${item?.event_id}/${item?.market_type_id}/${this.data?.event?.event?.event_type_id}` : `${this.api.removeMultiMarket}/${item?.market_id}`;
    
        this.getServices().Get(`${this.env.baseUrl + this.api.multiMarket + url}`).subscribe(
          (res) => {
            if (res.status == true) {
              if (key == 'save') {
                this.multiMarketIds.push(item?.market_id)
              } else {
                const index = this.multiMarketIds.indexOf(item?.market_id);
                if (index > -1) {
                  this.multiMarketIds.splice(index, 1); // 2nd parameter means remove one item only
                }
                // this.multiMarketIds = this.multiMarketIds.filter(item => item !== item?.market_id)
              }
              this._message.succmessage(res?.data?.message);
              // this.fancyRun = JSON.parse(res.data.position);
              this.getData();
            }
          },
          (err) => {
            console.log(err)
          });
    }

    bsModalRef!: BsModalRef;
    openModalWithComponent(key: any) {
        const initialState: any = { key: key };
        this.bsModalRef = this.modalService.show((this.env.isMobile)?MMarketRuleComponent:DMarketRuleComponent, {
            initialState,
            class: `${this.env.isMobile ? 'modal-xl' : 'modal-full'}`
        });
        this.bsModalRef.content.closeBtnName = 'Close';
    }
    
    detailPage(e: any) {
        this.router.navigate([`${this.env.isMobile ? '/m/game-detail' : '/game-detail'}`, e.event_id]);
    }
    
    ngOnDestroy() {
        this.subs.forEach((s) => s.unsubscribe());
    }
}
